export function normalizeSearchText(value: unknown) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function includesNormalizedSearch(value: unknown, search: unknown) {
  const normalizedSearch = normalizeSearchText(search);
  if (!normalizedSearch) return true;
  return normalizeSearchText(value).includes(normalizedSearch);
}
